/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { DialogButtonBar } from '../Dialog/DialogButtonBar.js';
/**
 * Container for Buttons in modal.
 */
export const ModalButtonBar = (props) => (React.createElement(DialogButtonBar, { ...props }));
export default ModalButtonBar;
